import styled from "styled-components";

import { theme } from "../../styles/theme";

interface IContainerProps {
  isMenuOpen: boolean;
}

export const Container = styled.div<IContainerProps>`
  height: 100%;
  width: ${(props) => (props.isMenuOpen ? "16em" : "5em")};
  background-color: ${theme.colors.darkBlue};
  padding-top: 40px;

  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;

  transition: width 0.3s ease;

  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.isMenuOpen ? "flex-start" : "center")};

  svg[aria-label="menu"] {
    margin-left: ${(props) => (props.isMenuOpen ? "20px" : "0")};

    path {
      fill: ${theme.colors.blue400};
    }
  }

  @media screen and (max-width: 768px) {
    position: absolute;
    width: 50vw;
    transform: translateX(${(props) => (props.isMenuOpen ? "0" : "-100%")});
    opacity: ${(props) => (props.isMenuOpen ? "1" : "0")};
    display: flex;
    z-index: 1000;
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;

    &::before {
      content: "";
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: -1;
      opacity: ${(props) => (props.isMenuOpen ? "1" : "0")};
      transition: opacity 0.3s ease-in-out;
      pointer-events: ${(props) => (props.isMenuOpen ? "auto" : "none")};
    }
  }
`;

export const Items = styled.div`
  margin-top: 30px;
  height: 20em;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
